const SvgStarComponent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
    <path
      fill={'currentColor'}
      fillRule="evenodd"
      d="M12.662 4.153a.75.75 0 0 0-1.332 0L9.015 8.582l-5.018.833a.749.749 0 0 0-.413 1.265l3.576 3.653-.76 5.056a.75.75 0 0 0 1.08.78l4.516-2.288 4.518 2.288a.75.75 0 0 0 1.079-.78l-.763-5.054 3.576-3.653a.751.751 0 0 0-.413-1.264l-5.018-.834-2.313-4.431Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStarComponent;
